import store from 'store2';

export default class Storage {
  constructor(id) {
    this._id = id;
  }

  initialize() {
    return Promise.resolve();
  }

  clear() {
    store.remove(this._id);
  }

  read() {
    return store.get(this._id);
  }

  write(value) {
    if (value) {
      store.set(this._id, value);
    }
    else {
      store.remove(this._id);
    }

    return Promise.resolve();
  }
};
